import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";

import CPF from "gerador-validador-cpf";

import { Access } from 'common';
import { Icon } from "components";

class Document extends Component {
  state = {
    open: false,
  };

  handleToggle = () => {
    const { open } = this.state;

    this.setState({ open: !open });
  };

  getTranslatedProfessionTitle = (profession) => {
    if (!profession?.title) return null;

    const { title } = profession;
    switch (title.toLowerCase()) {
      case "architect":
        return "ARQUITETO";
      case "potter":
        return "OLEIRO";
      case "builder":
        return "CONSTRUTOR";
      case "interiordesigner":
        return "DESIGNER DE INTERIORES";
      case "electrician":
        return "ELETRICISTA";
      case "plumber":
        return "ENCANADOR";
      case "engineer":
        return "ENGENHEIRO";
      case "gardener":
        return "JARDINEIRO";
      case "woodworker":
        return "MARCENEIRO";
      case "others":
        return "OUTROS";
      case "landscapedesigner":
        return "PAISAGISTA";
      case "bricklayer":
        return "PEDREIRO";
      case "painter":
        return "PINTOR";
      case "locksmith":
        return "SERRALHEIRO";
      case "personalorganizer":
        return "ORGANIZADOR PESSOAL";
      case "decorator":
        return "DECORADOR";
      default:
        return title.toUpperCase();
    }
  };

  render() {
    const { document, filters } = this.props;
    const { open } = this.state;

    const translatedProfessionTitle = this.getTranslatedProfessionTitle(
      document.attributes.document.data.attributes.documentable.profession
    );

    return (
      <Fragment>
        <tr>
          <td>{document.attributes.inhabitant.name}</td>
          <td>
            {document.attributes.document.data.attributes.documentable.profession ? translatedProfessionTitle : '-'}
          </td>
          <td>{document.attributes.document.data.attributes.documentable.store_place.uf}</td>
          <td>{CPF.format(document.attributes.inhabitant.cpf)}</td>
          <td>{document.attributes.document.data.attributes.number}</td>
          <td className="row text-right">
            {Access.hasPermissions("edit-documents") && (
              <Fragment>
                <Link
                  to={{
                    pathname: `/documents/${document.id}/edit`,
                    filters,
                  }}
                  className="button-icon"
                >
                  <span className="glyph glyph-eye" />
                </Link>
                <button className="button-icon" onClick={this.handleToggle}>
                  <Icon name="plus" prefix="fa" />
                </button>
              </Fragment>
            )}
          </td>
        </tr>
        {open && (
          <tr>
            <td colSpan="7" style={{ maxWidth: 300 }}>
              <Fragment>
                <p>
                  <b>Nome Completo: </b>
                  {document.attributes.document.documentable.name}
                </p>
                <p>
                  <b>Data de Envio: </b>
                  {document.attributes.document.sentDate}
                </p>
                <p>
                  <b>Loja: </b>
                  {document.attributes.document.documentable.store_place.name}
                </p>
                {document.attributes.situation === "rejected" ||
                document.attributes.situation === "approved" ? (
                  <p>{`Responsável pela aprovação/reprovação do documento ${document.attributes.inhabitant.name}`}</p>
                ) : (
                  ""
                )}
              </Fragment>
            </td>
          </tr>
        )}
      </Fragment>
    );
  }
}

export default Document;
